import { isAllowed } from '@hotjar/feature-flags';
import type { Site } from '@hotjar/site';

export const FEATURE_PLAN = 'scale';

export const FEATURE_NAME = 'settings.integrations_webhooks';

export const GATE_FEEDBACK = 'feedback.webhooks';

export const GATE_ANALYTICS = 'analytics.webhooks';

export const UPSELL_REFERRER_ANALYTICS = 'analytics_product.integrations_webhooks';

export const UPSELL_REFERRER_FEEDBACK = 'feedback_product.integrations_webhooks';

export const PERMISSION_ENABLE = 'site-integrations-webhooks-write';

export const canUse = (site?: Site | null): boolean => isAllowed(FEATURE_NAME, site ?? null);
